"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferListMobile = void 0;
var offerListMobile_1 = require("./offerListMobile");
Object.defineProperty(exports, "OfferListMobile", { enumerable: true, get: function () { return __importDefault(offerListMobile_1).default; } });
